import React, { useState } from 'react';
import { Box } from 'grommet';
import SHDSelectable from '@ui/Selectable/SHDSelectable';
import { SHDSwiperProps } from './SHDSwiper.d';

const SHDSwiper: React.FC<SHDSwiperProps> = ({
  items,
  defaultSelectedId,
  onSelect,
  onClick,
  selectable = false,
  round = '24px',
  gap = 'medium',
  pad = 'medium',
}) => {
  const [selectedId, setSelectedId] = useState<string | null>(
    defaultSelectedId || null
  );

  const handleSelect = (id: string) => {
    if (selectable) {
      setSelectedId(id);
      onSelect?.(id);
    }
    onClick?.(id);
  };

  return (
    <Box
      direction="row"
      gap={gap}
      overflow="auto"
      pad={{ horizontal: pad }}
      style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
      }}
    >
      {items.map((item) => (
        <Box key={item.id} width={{ min: '120px' }}>
          {selectable ? (
            <SHDSelectable
              id={item.id}
              isActive={item.id === selectedId}
              onSelected={handleSelect}
              round={round}
            >
              {item.content}
            </SHDSelectable>
          ) : (
            <Box onClick={() => handleSelect(item.id)}>{item.content}</Box>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default SHDSwiper;
